'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@components/Input';
import { OnboardingStep } from '@components/Onboarding/TeacherOnboarding/components';

interface NameStepProps {
  firstName: string;
  lastName: string;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  errors?: { firstName?: boolean; lastName?: boolean };
}

export const NameStep: React.FC<NameStepProps> = ({ firstName, lastName, setFirstName, setLastName, errors }) => {
  const { t } = useTranslation('common');

  return (
    <OnboardingStep
      stepLabel={t('onboardingTeacher.stepTwo')}
      title={t('onboardingTeacher.yourName')}
      description={t('onboardingTeacher.stepTwoDescription')}
    >
      <Input
        type="firstName"
        id="firstName"
        placeholder={t('onboardingTeacher.enterFirstName')}
        name="firstName"
        label={t('onboardingTeacher.firstName')}
        required
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        hasError={errors?.firstName}
      />
      <Input
        type="lastName"
        id="lastName"
        placeholder={t('onboardingTeacher.enterLastName')}
        name="lastName"
        label={t('onboardingTeacher.lastName')}
        required
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        hasError={errors?.lastName}
      />
    </OnboardingStep>
  );
};